import axios from 'axios'
import store from '@/store'
import { settings } from '@/utils/settings'
import router from '@/router'

axios.interceptors.request.use((config) => {
  if (store.state?.auth?.accessToken) {
    config.headers.Authorization = `Bearer ${store.state?.auth?.accessToken}`
  }
  if (store.state?.preferences?.selectedSupplierId) {
    config.headers.SupplierId = store.state.preferences.selectedSupplierId
  }
  if (['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    config.headers.TenantPrefix = settings.TENANT_PREFIX
  }
  return config
})

axios.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      try {
        // This may throw an exception if a new valid token cannot be obtained for the user
        await store.dispatch('auth/getTokenSilently')
        // Assuming we have just fetched a new token, replay the previous axios request and continue on our merry way!
        return axios.request(error.config)
      } catch (e) {
        // Token is likely expired, so log the user out
        await store.dispatch('auth/logout')
        return Promise.reject(error)
      }
    } else if (
      error.response?.status === 566 ||
      error.response?.status === 567
    ) {
      if (
        router.currentRoute.path !== '/' &&
        router.currentRoute.path !== '/account/login'
      ) {
        await store.dispatch('auth/logout')
      }
      return Promise.reject(error)
    } else {
      return Promise.reject(error)
    }
  }
)

/**
 * @param {String} url - default url to use
 */
export const setDefaultUrl = (url) => {
  axios.defaults.baseURL = `${url}/api/`
}
